/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/* eslint-disable */
import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import ShortcutIcon from '@atlaskit/icon/core/migration/link-external--shortcut';
import { css, jsx } from '@emotion/react';
import { analyticsAttributes, getItemAnalyticsContext, NavigationAnalyticsContext, withAnalyticsContextData } from '../../common/utils/analytics';
import { FadeIn } from './fade-in';
import ItemLink from './item-link';
import { AnalyticsItemType } from '../../types';
import Heading from '@atlaskit/heading';
import { useIsSwitcherTeam25TestCohort } from '../components/experiment-provider';
var baseSectionContainerStyles = css({
  padding: "var(--ds-space-075, 6px)".concat(" 0")
});
var visualRefreshStyles = css({
  paddingTop: "var(--ds-space-100, 8px)",
  overflow: 'hidden',
  marginTop: '-1px',
  borderTop: "1px solid ".concat("var(--ds-border, #091E4224)")
});
var boxStyles = xcss({
  marginLeft: 'space.100',
  marginRight: 'space.100',
  marginTop: '0',
  marginBottom: 'space.100'
});
var secondarySectionTitleBaseStyles = xcss({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  marginTop: 'space.200',
  marginLeft: 'space.100',
  color: 'color.text.subtle',
  font: 'font.body.small',
  fontWeight: 'font.weight.bold',
  marginBottom: 'space.050'
});
var refreshedSecondarySectionTitleBaseStyles = xcss({
  marginTop: 'space.075',
  marginLeft: 'space.100',
  marginBottom: 'space.075',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: 'color.text.subtlest',
  fontWeight: 'font.weight.medium'
});
var sectionChildrenWrapperStyles = css({
  listStyleType: 'none',
  padding: 0,
  margin: 0
});
export var SectionContainerTitle = function SectionContainerTitle(_ref) {
  var title = _ref.title;
  var isVisualRefreshEnabled = useIsSwitcherTeam25TestCohort();
  return jsx(Heading, {
    as: "h3",
    size: "xxsmall"
  }, jsx(Box, {
    xcss: isVisualRefreshEnabled ? refreshedSecondarySectionTitleBaseStyles : secondarySectionTitleBaseStyles
  }, title));
};
var SectionContainerComponent = function SectionContainerComponent(_ref2) {
  var title = _ref2.title,
    titleLink = _ref2.titleLink,
    children = _ref2.children,
    actionSubject = _ref2.actionSubject,
    sectionId = _ref2.sectionId,
    sectionRole = _ref2.sectionRole,
    ariaLabel = _ref2.ariaLabel;
  var isVisualRefreshEnabled = useIsSwitcherTeam25TestCohort();
  return React.Children.toArray(children).some(Boolean) ? jsx("section", {
    css: isVisualRefreshEnabled ? visualRefreshStyles : baseSectionContainerStyles,
    "data-testid": "".concat(sectionId, "__section"),
    role: sectionRole,
    "aria-label": ariaLabel
  }, jsx(Box, {
    xcss: isVisualRefreshEnabled ? boxStyles : undefined
  }, jsx(FadeIn, null, title && jsx(SectionContainerTitle, {
    title: title
  }), titleLink && jsx(TitleLink, {
    titleLink: titleLink,
    actionSubject: actionSubject
  })), jsx("ul", {
    css: sectionChildrenWrapperStyles
  }, children))) : null;
};
var TitleLink = function TitleLink(_ref3) {
  var titleLink = _ref3.titleLink,
    actionSubject = _ref3.actionSubject;
  return jsx(NavigationAnalyticsContext, {
    key: titleLink.key,
    data: getItemAnalyticsContext(0, titleLink.key, AnalyticsItemType.PRODUCT, titleLink.productType)
  }, jsx(ItemLink, {
    href: titleLink.href,
    iconAfter: jsx(ShortcutIcon, {
      LEGACY_size: "small",
      color: "currentColor",
      label: ""
    }),
    label: titleLink.label,
    testId: "section-title__link",
    actionSubject: actionSubject,
    ariaLabel: titleLink.ariaLabel
  }));
};
export var SectionContainer = withAnalyticsContextData(function (props) {
  return analyticsAttributes({
    group: props.sectionId,
    groupItemsCount: React.Children.toArray(props.children).filter(function (child) {
      return /*#__PURE__*/React.isValidElement(child);
    }).length
  });
})(SectionContainerComponent);

/* eslint-enable */